<section class="page">
    <div class="container">
        <div class="page-wrapper">
            <div class="page-header">
                <h1 class="page-title">
                    {{data.nome}}
                </h1>
                <div class="page-header__buttons">
                    <button mat-raised-button color="primary" type="button" (click)="openCreditsDialog()">
                        DISTRIBUIR CRÉDITOS
                    </button>
                    <button mat-stroked-button color="primary" type="button" routerLink="/admin/imobiliarias">
                        VOLTAR
                    </button>
                </div>
            </div>
            <form class="page-form" (ngSubmit)="submit(form)" #form="ngForm">

                <mat-progress-bar mode="indeterminate" class="page-form-loading" *ngIf="!data.id"></mat-progress-bar>
                <div class="page-form-loading-shade" *ngIf="!data.id"></div>

                <h3 class="page-form__title">
                    Dados da imobiliária
                </h3>

                <mat-form-field class="page-form-control half">
                    <input matInput type="text" placeholder="Nome" [(ngModel)]="data.nome" name="nome" required>
                </mat-form-field>

                <mat-form-field class="page-form-control quad">
                    <input matInput type="text" placeholder="Plano" [(ngModel)]="data.plano.nome" name="plano" required
                        readonly disabled>
                </mat-form-field>

                <mat-form-field class="page-form-control quad">
                    <mat-label>Contato Default</mat-label>
                    <mat-select name="contatoDefault" [(ngModel)]="data.contatoDefault" required>
                        <mat-option value="C">Corretor</mat-option>
                        <mat-option value="I">Imobiliária</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="page-form-control third">
                    <input matInput type="email" placeholder="E-mail" [(ngModel)]="data.email" name="email"
                        [pattern]="helper.emailRegex" required>
                </mat-form-field>

                <mat-form-field class="page-form-control third">
                    <input matInput type="tel" placeholder="Telefone" [(ngModel)]="data.telefone" name="telefone"
                        (ngModelChange)="changePhoneMask($event, 'phoneMask')" [mask]="phoneMask" required>
                </mat-form-field>

                <mat-form-field class="page-form-control third">
                    <input matInput type="tel" placeholder="Whatsapp" [(ngModel)]="data.whatsapp" name="whatsapp"
                        (ngModelChange)="changePhoneMask($event, 'whatsappMask')" [mask]="whatsappMask" required>
                </mat-form-field>

                <mat-form-field class="page-form-control half">
                    <input matInput type="text" placeholder="Razão Social" [(ngModel)]="data.razaoSocial"
                        name="razaoSocial" required (ngModelChange)="data.razaoSocial = $event.toLocaleUpperCase()"
                        disabled readonly>
                </mat-form-field>

                <mat-form-field class="page-form-control half">
                    <input matInput type="tel" placeholder="CNPJ" [(ngModel)]="data.cnpj" name="cnpj"
                        mask="00.000.000/0000-00" required disabled readonly>
                </mat-form-field>

                <mat-form-field class="page-form-control">
                    <textarea matInput rows="6" placeholder="Descrição" [(ngModel)]="data.descricao"
                        name="descricao"></textarea>
                </mat-form-field>

                <h3 class="page-form__title">
                    Imagem (1000x1000)
                </h3>

                <div class="upload-section">
                    <div class="upload-section__image">
                        <img [src]="data.imagem ? global.imageUrl+data.imagem : 'assets/image-placeholder.png'"
                            alt="Upload">
                    </div>
                    <button mat-stroked-button color="primary" type="button" (click)="openUploadDialog()">
                        Fazer upload
                    </button>
                </div>

                <h3 class="page-form__title">
                    Endereço
                </h3>

                <mat-form-field class="page-form-control">
                    <input matInput type="tel" placeholder="CEP" [(ngModel)]="data.cep" mask="00000-000" name="cep"
                        (blur)="onCepBlur($event)" required>
                </mat-form-field>

                <mat-form-field class="page-form-control third">
                    <input matInput type="text" placeholder="Estado (UF)" [(ngModel)]="data.uf" name="uf" required>
                </mat-form-field>

                <mat-form-field class="page-form-control two-third">
                    <input matInput type="text" placeholder="Cidade" [(ngModel)]="data.cidade" name="cidade" required>
                </mat-form-field>

                <mat-form-field class="page-form-control third">
                    <input matInput type="text" placeholder="Bairro" [(ngModel)]="data.bairro" name="bairro" required>
                </mat-form-field>

                <mat-form-field class="page-form-control two-third">
                    <input matInput type="text" placeholder="Endereço" [(ngModel)]="data.endereco" name="endereco"
                        required>
                </mat-form-field>

                <mat-form-field class="page-form-control third">
                    <input matInput type="tel" placeholder="Número" mask="0*" [(ngModel)]="data.enderecoNumero"
                        name="enderecoNumero" #enderecoNumeroInput required>
                </mat-form-field>

                <mat-form-field class="page-form-control two-third">
                    <input matInput type="text" placeholder="Complemento" [(ngModel)]="data.complemento"
                        name="complemento">
                </mat-form-field>

                <hr>

                <button mat-raised-button color="primary" type="submit" [disabled]="loadingService.active">
                    SALVAR
                </button>

            </form>
        </div>
    </div>
</section>